// SELECTING A CUSTOM CATEGORY IN THE MODEL, in one place.
//
// Two panels now offer it - the custom category list and the row in the
// model tree (owner, 2026-10-04: "do the custom categories in the tree") -
// and every caveat below is one a person acts on, so a second copy is a
// second place for them to drift:
//
//   - over the resolver's limit the server refuses the WHOLE list and this
//     says how many there were, because "there are 255,396" is actionable
//     and a shrug is not;
//   - no parts is an ANSWER, not a failure: a definition can legitimately
//     match nothing in the model published today;
//   - when the exporter counted more parts than it listed ids for, the
//     difference is said out loud rather than letting the selection stand
//     for a smaller number than the one printed beside it.
//
// The DEFINITION's id travels with the ids: the server cannot tell a part
// id from an element id a re-export dropped, and this is what lets it (see
// bulkRows' partsFrom).
import { message } from "antd";
import { expandCompact } from "helpers/treeRowUids";
import { getDerivedCategoryUids } from "api/tracking/trackingElementsApi";

const n = (v) => Number(v || 0).toLocaleString();

export default async function selectDerivedParts({ projectId, documentIds = "", id, name = "", onSelect }) {
  const defId = String(id || "");
  if (!defId || !onSelect) return false;
  const r = await getDerivedCategoryUids(projectId, defId, { documentIds: documentIds || undefined });
  if (r && r.tooMany) {
    message.info(`${n(r.count)} parts is more than this can select at once (${n(r.limit)}). Narrow the part type and make a second category.`);
    return false;
  }
  const uids = expandCompact(r || {});
  if (!uids.length) {
    message.info(`${name} matches no parts in the current model.`);
    return false;
  }
  if (r.withoutIds) {
    message.info(`${n(uids.length)} of ${n(r.parts)} parts could be selected; the model lists no id for the other ${n(r.withoutIds)}.`);
  }
  onSelect(uids, name, defId);
  return true;
}
